<template>
    <slot v-if="isEnabled"></slot>
</template>

<script>
import { mapState } from 'pinia';
import { useFeatureFlagsStore } from '@/stores/featureFlags.js';

export default {
    name: 'p-feature-flag',
    data(){
        return {
            tries: 0
        };
    },
    props: {
        name: String,
        redirect: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState(useFeatureFlagsStore, ['featureFlagEnabled']),
        isEnabled() {
            return this.featureFlagEnabled(this.name);
        }
    },
    updated: async function () {
        if (this.isEnabled == undefined && this.redirect) {
            this.tries++;
            if(this.tries > 2)
            {
                this.$router.replace('/');
            }
        }
    }
};
</script>

<style>
</style>
